import { trace } from 'rytm-helpers'
import imagesLoaded from 'imagesloaded'
import { store } from './../store'
import { mediaLoadStart, mediaLoadComplete } from './../actions/actions_gui'

const CLASS_IMG_LOADING = "loading"
const CLASS_IMG_LOADED = "loaded"
let currentView = null

export const initImagesState = () => {
  store.subscribe(onStoreChange)
}
/**
 * update images state
 */
const updateImagesState = () => {
  const list = [...document.querySelectorAll(".tsaw-image-view")]
  list.forEach(checkImage)
}

const checkImage = (el, index) => {
  if (!el.classList.contains(CLASS_IMG_LOADING) 
      && !el.classList.contains(CLASS_IMG_LOADED)) {
    el.classList.add(CLASS_IMG_LOADING)
    mediaLoadStart(el.dataset.id)
    imagesLoaded(el, onTsawImagesLoaded)
  }
}
const onTsawImagesLoaded = (ilInstance) => {
  const list = [...ilInstance?.elements]
  list.forEach(onTsawImageLoaded)
}
const onTsawImageLoaded = (el, index) => {
  el.classList.remove(CLASS_IMG_LOADING)
  el.classList.add(CLASS_IMG_LOADED)
  mediaLoadComplete(el.dataset.id)
}

/**
 * ########################
 * # State event handlers #
 */
 const onStoreChange = () => {
  const state = store.getState()
  // check view change
  if (state.reducerRouter.view !== currentView) {
    currentView = state.reducerRouter.view
    // check images
    updateImagesState()   
  }
 }
 